import PropTypes from 'prop-types';

const LoadingLine = ({ height, width, ...rest }) => (
  <span
    {...rest}
    className="animate-loading rounded bg-gray-2 bg-loading bg-no-repeat inline-block leading-none"
    style={{ height, width, backgroundSize: '200px 100%' }}
  >
    &zwnj;
  </span>
);

LoadingLine.defaultProps = {
  height: 24,
  width: '100%',
};

LoadingLine.propTypes = {
  /**
   * The height the line will be set to, either a number or string value such as "3rem".
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The width the line will be set to that will override the default of full width of parent container – either a number or string value such as "50%".
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default LoadingLine;
